export function editorConfig({ colors }) {
    return {
        toolbar: {
            background: colors.background.toolbarBackground
        }
    };
}
